export default __webpack_public_path__ + "static/media/pochta-bank.67ab3f35.png";